import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AgentModule } from "../../autogen/bff-api";

export type AiSkillLabel = { name: string; description: string };

export const useAiSkillLabels = (): ((skill: AgentModule) => AiSkillLabel) => {
  const { t } = useTranslation();
  return useCallback(
    (skill: AgentModule): AiSkillLabel => {
      switch (skill) {
        case AgentModule.Assistant:
          return {
            name: t("The assistant"),
            description: t(
              "Answers questions and does tasks for you across SourceMagnet.",
            ),
          };
        case AgentModule.DocumentChat:
          return {
            name: t("Chat with document"),
            description: t(
              "Answers questions about the documents in a procurement or a contract.",
            ),
          };
        case AgentModule.BidInsight:
          return {
            name: t("Bid insight"),
            description: t(
              "Summarises each bid you receive, for you to check against the bid before you assess it.",
            ),
          };
        case AgentModule.ContractSearch:
          return {
            name: t("Contract search"),
            description: t("Searches the content of your contracts."),
          };
      }
    },
    [t],
  );
};
